import React, { useEffect, useState } from 'react';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'amp-ad': any;
    }
  }
}

interface AdBannerProps {
  slot: string;
  format?: 'auto' | 'rectangle' | 'vertical' | 'horizontal';
  responsive?: boolean;
  className?: string;
  minHeight?: string;
}

const AdBanner: React.FC<AdBannerProps> = ({
  slot,
  format = 'auto',
  responsive = true,
  className = '',
  minHeight = '90px'
}) => {
  const [adBlocked, setAdBlocked] = useState(false);

  useEffect(() => {
    // Delay AdSense initialization to avoid conflicts
    const timer = setTimeout(() => {
      try {
        // Initialize AdSense ads
        if (window.adsbygoogle && Array.isArray(window.adsbygoogle)) {
          window.adsbygoogle.push({});
        }
      } catch (err) {
        console.warn('AdSense blocked or unavailable');
        setAdBlocked(true);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const publisherId = process.env.REACT_APP_ADSENSE_PUBLISHER_ID || 'ca-pub-8653106021284502';

  return (
    <div className={`ad-container relative overflow-hidden rounded-lg bg-gray-50/50 dark:bg-gray-800/30 flex items-center justify-center border border-dashed border-gray-200 dark:border-gray-700 ${className}`} style={{ minHeight }}>
      {/* Background Placeholder Text (Only visible if ad hasn't loaded yet) */}
      <div className="absolute inset-0 flex flex-col items-center justify-center opacity-40 pointer-events-none">
        <span className="text-[10px] uppercase tracking-widest font-bold text-gray-400 dark:text-gray-500">Advertisement</span>
      </div>

      <ins
        className="adsbygoogle"
        style={{ display: 'block', width: '100%', height: '100%' }}
        data-ad-client={publisherId}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive.toString()}
      />

      {/* Fallback info for developers or ad blockers */}
      {adBlocked && (
        <div className="absolute inset-0 bg-gray-100/50 dark:bg-gray-900/50 flex items-center justify-center backdrop-blur-[2px]">
          <p className="text-[10px] text-gray-400 font-medium italic">Ad source unavailable or blocked</p>
        </div>
      )}
    </div>
  );
};

export default AdBanner;